/**
 * Enum des codes BIC des banques avec leurs logos associés
 */
export enum BankBicCodes {
    AMEX = 'AMEXXXXXXXX',
    BANQUE_TAHITI = 'CEPAPFTPXXX',
    BEBUNK = 'SMOEFRP1',
    BCI = 'BCADNCNNXXX',
    BNC = 'CEPANCNMXXX',
    BNP = 'BNPANCNXXXX',
    OPT_NC = 'CEFNNCN1XXX',
    SG = 'SOGENCNNXXX',
    SOCREDO = 'SOCBPFTXXXX'
}

/**
 * Mapping des codes BIC vers les fichiers de logos
 */
export const BankBicLogos: { [key: string]: string } = {
    [BankBicCodes.AMEX]: 'logo-amex.png',
    [BankBicCodes.BANQUE_TAHITI]: 'logo-banque-tahiti.jpeg',
    [BankBicCodes.BEBUNK]: 'logo-bebunk.png',
    [BankBicCodes.BCI]: 'logo-bci.png',
    [BankBicCodes.BNC]: 'logo-bnc.png',
    [BankBicCodes.BNP]: 'logo-bnp.png',
    [BankBicCodes.OPT_NC]: 'logo-opt.png',
    [BankBicCodes.SG]: 'logo-sg.png',
    [BankBicCodes.SOCREDO]: 'logo-socredo.png'
};
